import controller from './query-rule-having.controller';
import template from './query-rule-having.html';
import './query-rule-having.scss';

export default {
	controller,
	template,
	bindings: {
		change:   '&ngChange',
		disabled: '<?ngDisabled',
		having:   '=ngModel',
		rule:     '<',
	},
	require: {
		editor: '^^?queryEditor',
		tree: '^^?queryBuilderChildren',
	},
};
